export function newStatusMap(status, pendingReason) {
  const normalizedStatus = (status || '').toLowerCase();
  const normalizedPendingReason = (pendingReason || '').toLowerCase();

  const statusMap = {
    closed: 'Completed',
    rejected: 'Completed',
    expired: 'Expired- Call Pfizer Account Provisioning Team',
    'in progress': 'In Progress',
    submitted: 'In Progress',
    approved: 'In Progress',
    'not available yet': 'Pending Pfizer Action',
    'sent for provisioning': 'Pending Pfizer Action',
    'training not completed': 'Pending Site Action - Complete Required Training',
  };

  const pendingReasonMap = {
    'email or name mismatch': 'Pending Site Action - Verify Email Address',
    'exostar issues - nascent account': 'Pending Site Action - Activate Exostar Account',
    'exostar merges - pending site feedback': 'Pending Site Action - Confirm Exostar Merge ',
    'missing payee name (eclinicalgps)': 'Pending Site Action - Verify Payee Name',
    'missing sip/exostar id': 'Pending Site Action - Complete SIP Registration',
  };

  if (normalizedStatus === 'pending') {
    return pendingReasonMap[normalizedPendingReason] || 'Pending Pfizer Action';
  }

  return statusMap[normalizedStatus] || 'Pending Pfizer Action';
}
